var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.708 55.208V44.1663C187.708 31.97 177.822 22.083 165.625 22.083H99.375C87.1787 22.083 77.2917 31.97 77.2917 44.1663V55.208H44.1667C38.0686 55.208 33.125 60.1516 33.125 66.2497C33.125 72.3478 38.0686 77.2913 44.1667 77.2913H55.2083V198.75C55.2083 217.045 70.0389 231.875 88.3333 231.875H176.667C194.962 231.875 209.792 217.045 209.792 198.75V77.2913H220.833C226.932 77.2913 231.875 72.3478 231.875 66.2497C231.875 60.1516 226.932 55.208 220.833 55.208H187.708ZM165.625 44.1663H99.375V55.208H165.625V44.1663ZM187.708 77.2913H77.2917V198.75C77.2917 204.848 82.2352 209.791 88.3333 209.791H176.667C182.765 209.791 187.708 204.848 187.708 198.75V77.2913Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.375 99.375H121.458V187.708H99.375V99.375Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.542 99.375H165.625V187.708H143.542V99.375Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash_red.54822af179d9556de65952925cf8118f.svg";
export { ForwardRef as ReactComponent };